module.exports = __webpack_public_path__ + "static/media/special_set.d2fb74f5.png";